import { useTranslate } from "@/hooks/useTranslate";
import {
  BUSINESS_REQUEST_DEMO_SUCCESS_HERO_TITLE,
  BUSINESS_ENTERPRISE_SUCCESS_TITLE,
} from "@/constants/tempTranslations";
import { RichText } from "@/components/atoms";
import CustomButton from "@/components/molecules/CustomButton";
import React from "react";
import { internalLinks } from "@/constants/internalLinks";
import cn from "classnames";
import {
  h3Text,
  marginBMd,
  marginBSm,
  marginTMd,
} from "@/constants/standardCSSClasses";
import {
  BUSINESS_DEMO_SUCCESS_ACCOUNT_EXECUTIVE_MESSAGE,
  BUSINESS_DEMO_SUCCESS_BUY_NOW,
  BUSINESS_DEMO_SUCCESS_BENEFIT_ENFORCE_POLICIES,
  BUSINESS_DEMO_SUCCESS_BENEFIT_SECURE_CREDENTIALS,
  BUSINESS_DEMO_SUCCESS_BENEFIT_SIMPLIFY_MANAGEMENT,
  BUSINESS_DEMO_SUCCESS_CTA_MESSAGE,
  BUSINESS_DEMO_SUCCESS_PASSWORD_MANAGEMENT_INTRO,
  BUSINESS_DEMO_SUCCESS_SMALL_COMPANY_EVALUATION,
} from "@/i18n/translations";
interface Props {
  bookItParam: string;
  inboundCompanySize: string;
}

export default function DemoFormSuccess(props: Props) {
  const { bookItParam, inboundCompanySize } = props;
  const { translate } = useTranslate();
  const isSmallCompany =
    inboundCompanySize === "1-20" || inboundCompanySize === "21-50";
  const isLargeCompany =
    inboundCompanySize !== "1-20" && inboundCompanySize !== "21-50";

  const listStyles = cn(marginBSm, "list-disc", "list-inside", "ml-4");
  const listItemStyles = cn("mb-2");

  return (
    <>
      {isLargeCompany ? (
        <RichText tag="h1" className={cn(h3Text, marginBMd)}>
          {translate(BUSINESS_REQUEST_DEMO_SUCCESS_HERO_TITLE)}
        </RichText>
      ) : (
        <RichText tag="h1" className={cn(h3Text, marginBMd)}>
          {translate(BUSINESS_ENTERPRISE_SUCCESS_TITLE)}
        </RichText>
      )}

      {bookItParam && isLargeCompany && (
        <RichText tag="p" className={marginBSm}>
          {translate(BUSINESS_DEMO_SUCCESS_ACCOUNT_EXECUTIVE_MESSAGE)}
        </RichText>
      )}

      {!bookItParam && isSmallCompany && (
        <>
          <RichText tag="p" className={marginBSm}>
            {translate(BUSINESS_DEMO_SUCCESS_SMALL_COMPANY_EVALUATION)}
          </RichText>
          <RichText tag="p" className={marginBSm}>
            {translate(BUSINESS_DEMO_SUCCESS_PASSWORD_MANAGEMENT_INTRO)}
          </RichText>
          <ul className={listStyles}>
            <RichText tag="li" className={listItemStyles}>
              {translate(BUSINESS_DEMO_SUCCESS_BENEFIT_SECURE_CREDENTIALS)}
            </RichText>
            <RichText tag="li" className={listItemStyles}>
              {translate(BUSINESS_DEMO_SUCCESS_BENEFIT_SIMPLIFY_MANAGEMENT)}
            </RichText>
            <RichText tag="li" className={listItemStyles}>
              {translate(BUSINESS_DEMO_SUCCESS_BENEFIT_ENFORCE_POLICIES)}
            </RichText>
          </ul>
          <RichText tag="p" className={marginBSm}>
            {translate(BUSINESS_DEMO_SUCCESS_CTA_MESSAGE)}
          </RichText>
        </>
      )}

      {isLargeCompany && (
        <RichText tag="p" className={marginBSm}>
          {translate(BUSINESS_DEMO_SUCCESS_ACCOUNT_EXECUTIVE_MESSAGE)}
        </RichText>
      )}

      {isSmallCompany && (
        <CustomButton
          className={marginTMd}
          variant="dark"
          href={internalLinks.businessBuy}
          text={translate(BUSINESS_DEMO_SUCCESS_BUY_NOW)}
        />
      )}
    </>
  );
}
